import { render, staticRenderFns } from "./SelectTratamientos.vue?vue&type=template&id=456a887f&scoped=true"
import script from "./SelectTratamientos.vue?vue&type=script&lang=js"
export * from "./SelectTratamientos.vue?vue&type=script&lang=js"
import style0 from "./SelectTratamientos.vue?vue&type=style&index=0&id=456a887f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a887f",
  null
  
)

export default component.exports